import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import aboutAPI from "../api/aboutApi";

const CertificateViewer = () => {
  const { slug } = useParams();

  const [certificate, setCertificate] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCertificate = async () => {
      try {
        const res = await aboutAPI.certificates();

        if (res.code === 200) {
          const data = res.data || [];

          const selectedCertificate = data.find(
            (item) => item.slug === slug
          );

          setCertificate(selectedCertificate || null);
        }
      } catch (error) {
        console.error("Error fetching certificate:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCertificate();
  }, [slug]);

  if (loading) {
    return (
      <div className="custom-certificate-loading">
        <div className="spinner-border" role="status"></div>
      </div>
    );
  }

  if (!certificate) {
    return (
      <div className="custom-certificate-not-found">
        <h2>Certificate not found</h2>
      </div>
    );
  }

  return (
    <div className="custom-certificate-viewer">
      <iframe
        src={certificate.image}
        title={certificate.title}
        className="custom-certificate-iframe"
      />
    </div>
  );
};

export default CertificateViewer;